import styled from 'styled-components';
import { fonts } from '../../styles/theme';
import toRem from '../../utils/toRem';

export const TextBlockStyled = styled.div`
  ${fonts.font1.H16};
  line-height: ${toRem(26)};
`;
